import script from "./shareInstitution.vue?vue&type=script&setup=true&lang=js"
export * from "./shareInstitution.vue?vue&type=script&setup=true&lang=js"

import "./shareInstitution.vue?vue&type=style&index=0&id=3cd788b0&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd788b0"]])

export default __exports__